// removed by extract-text-webpack-plugin
module.exports = {"byline":"dh-trygdis-kvinnefengsel-byline","byline__name":"dh-trygdis-kvinnefengsel-byline__name"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Article/Header/Byline.css
// module id = 213
// module chunks = 0